
import Vue from 'vue'
import CoinIcon from '@/components/CoinIcon.vue'

export default Vue.extend({
  components: {
    CoinIcon,
  },
  props: {
    loading: {
      type: Boolean,
    },
    value: {
      type: String,
    },
    text: {
      type: String,
    },
    color: {
      type: String,
      default: 'primary',
    },
    width: {
      type: String,
      default: '50px',
    },
    coins: {
      type: Boolean,
      default: false,
    },
  },
})
